// src/Services/carModelService.ts
// A CarModel belongs to a Brand (brandId) and lists its Trims inline — mirrors
// admin/src/admin/pages/carmodel/carModel.ts. Read-only on the client: models
// and trims are only managed from the admin panel.
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
} from 'firebase/firestore';
import { db } from '../Firebase/Config';

export interface Trim {
  id?: string;
  name: string;
  description?: string;
  isActive: boolean;
}

export interface CarModel {
  id: string;
  name: string;
  brandId: string;
  brandName?: string;
  trims: Trim[];
  isActive: boolean;
}

const CAR_MODELS_COLLECTION = 'carModels';

export class CarModelService {
  static async getActiveModelsByBrand(brandId: string): Promise<CarModel[]> {
    try {
      const q = query(
        collection(db, CAR_MODELS_COLLECTION),
        where('brandId', '==', brandId),
        where('isActive', '==', true),
        orderBy('name', 'asc')
      );
      const snapshot = await getDocs(q);
      return snapshot.docs.map(docSnap => ({
        id: docSnap.id,
        ...docSnap.data(),
      } as CarModel));
    } catch (error) {
      console.error('Error fetching car models by brand:', error);
      throw new Error('Failed to fetch car models');
    }
  }
}
